import { useEffect } from 'react';

import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

import { REACT_APP_GA_TRACKING_ID } from 'config_app';

const useGoogleAnalytics = () => {
  const location = useLocation();
  const initGoogleAnalytics = ['staging', 'prod'].includes(ENVIRONMENT);

  const init = () => {
    ReactGA.initialize(REACT_APP_GA_TRACKING_ID);
  };

  // https://www.npmjs.com/package/react-ga4#:~:text=//%20Send%20pageview%20with%20a%20custom%20path
  // we also can just send the path, but it's clear to send it with a hitType and title so it's clear while checking on analytics
  const sendPageview = path => {
    ReactGA.set({ page: path });
    ReactGA.send({
      // to specify what we actually send
      hitType: 'pageview',
      // Title of what we send as field object
      title: 'Page View',
      // sent page to the analytics
      page: path,
    });
  };

  useEffect(() => {
    if (initGoogleAnalytics) {
      init();
    }
  }, []);

  useEffect(() => {
    if (!initGoogleAnalytics) {
      return;
    }

    const currentPath = location.pathname + location.search;
    sendPageview(currentPath);
  }, [location]);
};

export default useGoogleAnalytics;
